import { ControlValueAccessor } from '@angular/forms';

export class InnerValueAccessor implements ControlValueAccessor {
  private _innerValue: any;

  onChange = (_: any) => {};
  onTouched = () => {};

  get value(): any {
    return this._innerValue;
  }

  set value(value: any) {
    if (value !== this._innerValue) {
      this._innerValue = value;
      this.onChange(value);
    }
  }

  writeValue(value: any): void {
    this._innerValue = value;
  }

  registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/simple-mde/inner_value_accessor.ts